import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ContentTop } from "common/src/component/ContentTop";
import { isMobileOnly } from "react-device-detect";
import { withRouter } from "react-router";
import {
  AboutContainer,
  AccountContainer,
  AccountDescription,
  PageContent,
  PageContentWrapper,
  StyledPageHeader,
  StyledPageHeaderWrapper,
} from "common/src/styledComponents/AccountPage";
import { StyledLink } from "common/src/styledComponents/CommonStyledComponents";

const Bonus = ({ pageWidth, pages, titles, skin }) => {
  const { t } = useTranslation();

  useEffect(() => {
    // console.log(titles)
    document.title = titles["bonus"];
  }, [titles]);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    };
    scrollToTop();
  }, []);

  return (
    <>
      <ContentTop showProfileMenu={false} skin={skin} pages={pages} />
      <PageContent>
        <PageContentWrapper>
          <AccountContainer>
            <AboutContainer>
              <StyledPageHeaderWrapper>
                <StyledPageHeader
                  dangerouslySetInnerHTML={{
                    __html: t("label_bonus_title", "Bonus"),
                  }}
                ></StyledPageHeader>
              </StyledPageHeaderWrapper>
              {/* {!isMobileOnly && (
                <StyledPageHeaderWrapper right>
                  <StyledLink
                    as={"a"}
                    to=""
                    btnsolo="true"
                    btnnext="true"
                    href="https://affiliates.pubcasino.co.uk"
                    target="_blank"
                    rel="noopener noreferrer"
                    dangerouslySetInnerHTML={{
                      __html: t("label_next_affiliates", "Next: Affiliates"),
                    }}
                  ></StyledLink>
                </StyledPageHeaderWrapper>
              )} */}
            </AboutContainer>
            <AccountDescription
              dangerouslySetInnerHTML={{ __html: t("text_bonus") }}
            ></AccountDescription>
          </AccountContainer>
        </PageContentWrapper>
      </PageContent>
    </>
  );
};

export default withRouter(Bonus);
